import { render, staticRenderFns } from "./PepStatus.vue?vue&type=template&id=45a83d19&"
import script from "./PepStatus.vue?vue&type=script&lang=js&"
export * from "./PepStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports